import React, { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';

export default function DailyNubbi() {
  const [schedule, setSchedule] = useState(null);
  const [unlocked, setUnlocked] = useState({ morning: null, evening: null });
  const [now, setNow] = useState(new Date());
  const [dailyList, setDailyList] = useState([]);

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 60000);
    loadSchedule();
    fetchDailyList();
    return () => clearInterval(interval);
  }, []);

  const loadSchedule = () => {
    const today = new Date().toISOString().split('T')[0];
    const stored = localStorage.getItem('dailyNubbi_' + today);
    if (stored) {
      const parsed = JSON.parse(stored);
      setSchedule(parsed.schedule);
      setUnlocked(parsed.unlocked);
    } else {
      const morningHour = Math.floor(Math.random() * (13 - 7 + 1)) + 7;
      const morningMinute = Math.floor(Math.random() * 60);
      const eveningHour = Math.floor(Math.random() * (20 - 15 + 1)) + 15;
      const eveningMinute = Math.floor(Math.random() * 60);
      const schedule = {
        morning: `${String(morningHour).padStart(2, '0')}:${String(morningMinute).padStart(2, '0')}`,
        evening: `${String(eveningHour).padStart(2, '0')}:${String(eveningMinute).padStart(2, '0')}`,
      };
      setSchedule(schedule);
      setUnlocked({ morning: null, evening: null });
      localStorage.setItem(
        'dailyNubbi_' + today,
        JSON.stringify({ schedule, unlocked: { morning: null, evening: null } })
      );
    }
  };

  const fetchDailyList = async () => {
    const { data, error } = await supabase
      .from('daily_nubbi')
      .select('*')
      .order('date_created', { ascending: true });

    if (!error) setDailyList(data);
  };

  const unlock = (slot) => {
    const today = new Date().toISOString().split('T')[0];
    const available = dailyList.filter((d) => !unlocked.morning || d.id !== unlocked.morning);
  
    if (available.length === 0) {
      console.warn('No characters available to unlock for slot:', slot);
      return;
    }
  
    const random = available[Math.floor(Math.random() * available.length)];
  
    if (!random) {
      console.error('Random selection failed');
      return;
    }
  
    const newUnlocked = { ...unlocked, [slot]: random.id };
    setUnlocked(newUnlocked);
    localStorage.setItem(
      'dailyNubbi_' + today,
      JSON.stringify({ schedule, unlocked: newUnlocked })
    );
  };

  const renderSlot = (label, timeKey) => {
    const scheduledTime = schedule ? schedule[timeKey] : null;
    const character = dailyList.find((c) => c.id === unlocked[timeKey]);

    let isAvailable = false;
    if (scheduledTime) {
      const [scheduledHour, scheduledMinute] = scheduledTime.split(':').map(Number);
      const scheduledTotal = scheduledHour * 60 + scheduledMinute;
      const currentTotal = now.getHours() * 60 + now.getMinutes();
      isAvailable = currentTotal >= scheduledTotal && currentTotal <= scheduledTotal + 180;
    }

    return (
      <div style={{ marginBottom: '2rem' }}>
        <h3>{label} Drop</h3>
        {character ? (
          <div>
            <img
              src={character.image}
              alt={character.name}
              style={{ width: 300, borderRadius: '12px' }}
            />
            <p style={{ fontWeight: 'bold' }}>{character.name}</p>
          </div>
        ) : isAvailable ? (
          <button
            onClick={() => unlock(timeKey)}
            style={{
              padding: '1rem 2rem',
              fontSize: '1rem',
              backgroundColor: '#3B82F6',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer'
            }}
          >
            Unlock {label} Newbbi
          </button>
        ) : (
          <p>Come back at {scheduledTime} to unlock your {label.toLowerCase()} Newbbi!</p>
        )}
      </div>
    );
  };

  return (
    <div style={{ textAlign: 'center', padding: '2rem' }}>
      <h2>🎁 Daily Newbbi</h2>
      <p>Come back twice a day to unlock surprise characters!</p>
      {renderSlot('Morning', 'morning')}
      {renderSlot('Evening', 'evening')}
    </div>
  );
}